module.exports = __webpack_public_path__ + "img/1.Κέρκυρα-min.b657a972.jpg";